import { navigate, PageProps } from 'gatsby'
import clsx from 'clsx'
import moment from 'moment/moment'
import { staticCustomerType } from 'lib/constants'
import { OrderPurpose } from 'lib/graphql/storeadmin'
import {
  BookingInfoCard,
  LineItem,
  MemoCard,
  ProductSearch,
  TagsCard,
} from 'components/bookings'
import Layout from 'components/layouts/tow-column'
import {
  Button,
  Card,
  DateRangePicker,
  Divider,
  Icon,
  Paragraph,
  Select,
  SEO,
  Space,
  Tag,
  Text,
  Title,
} from 'components/common'

const onBack = () => navigate('../')

export const Head = () => <SEO title={'下書きの編集'} />

const IdPage = ({ params }: PageProps): JSX.Element => {
  return (
    <>
      <Layout
        title={`#D${params.id}`}
        tags={[
          <Tag color="blue" icon={<Icon.CheckCircleOutlined />}>
            支払い済み
          </Tag>,
        ]}
        pagination={{
          next: './',
        }}
        onBack={onBack}
      >
        <Layout.Section size="large">
          <Layout.Item>
            <Card shadow>
              <Title level={5}>予約日時</Title>

              <Space direction="vertical" size="middle">
                <div>
                  <div>
                    <Text strong>利用予定日</Text>
                  </div>
                  <DateRangePicker picker={'date'} />
                </div>

                <div>
                  <div>
                    <Text strong>利用予定時間帯</Text>
                  </div>
                  <Select defaultValue={1}>
                    <Select.Option value={1}>
                      9:00 - 12:00（半日）
                    </Select.Option>
                    <Select.Option value={2}>
                      12:00 - 15:00（半日）
                    </Select.Option>
                    <Select.Option value={3}>
                      15:00 - 18:00（半日）
                    </Select.Option>
                    <Select.Option value={4}>
                      18:00 - 21:00（半日）
                    </Select.Option>
                  </Select>
                </div>
              </Space>
            </Card>
          </Layout.Item>

          <Layout.Item>
            <Card shadow>
              <Title level={5}>予約対象</Title>

              <ProductSearch />

              <Card.Divider space="large" />

              <div className={clsx('mt-8')}>
                {new Array(10).fill(null).map(() => (
                  <LineItem
                    key={''}
                    title={'トレーニング室'}
                    price={1000}
                    baseTimeUnit={180}
                    variantTitle={'ダンベル'}
                    period={{ start: '0:00', end: '03:00' }}
                    isSagaArena={false}
                    date="2023-01-01"
                    specialPrice={200}
                  />
                ))}
              </div>
            </Card>
          </Layout.Item>

          <Layout.Item>
            <Card shadow>
              <div>
                <div
                  className={clsx('flex', 'justify-between', 'items-center')}
                >
                  <div className={clsx('flex', 'flex-initial', 'items-center')}>
                    <Icon.CheckCircleTwoTone twoToneColor="#52c41a" />
                  </div>
                  <div className={clsx('flex-auto', 'ml-3')}>支払い済み</div>
                </div>

                <div className={clsx('flex', 'justify-between', 'mt-3')}>
                  <div>小計</div>
                  <div>￥10,000</div>
                </div>
                <div className={clsx('flex', 'justify-between')}>
                  <div>消費税</div>
                  <div>￥1,000</div>
                </div>
                <div className={clsx('flex', 'justify-between')}>
                  <div>合計</div>
                  <div>￥11,000</div>
                </div>

                <Divider />

                <div
                  className={clsx('flex', 'justify-between', 'items-center')}
                >
                  <div className={clsx('flex-initial')}>
                    お客様より支払い済み
                  </div>
                  <div className={clsx('flex', 'flex-auto', 'justify-end')}>
                    ￥0
                  </div>
                </div>

                <div
                  className={clsx('flex', 'justify-between', 'items-center')}
                >
                  <div className={clsx('flex-initial')}>
                    残高（お客様の未払い金額）
                  </div>
                  <div className={clsx('flex', 'flex-auto', 'justify-end')}>
                    ￥11,000
                  </div>
                </div>
              </div>

              <Card.Divider space="large" />

              <div className={clsx('flex', 'justify-between', 'items-center')}>
                <Text strong>請求書を送信</Text>
                <Button>請求書を送信する</Button>
              </div>

              <Card.Divider space="large" />

              <div>
                <Paragraph strong>支払いを受け付ける</Paragraph>
                <div className={clsx('flex', 'justify-end')}>
                  <Space>
                    <Button>支払い済みとしてマークする</Button>
                    <Button>保留中としてマークする</Button>
                  </Space>
                </div>
              </div>
            </Card>
          </Layout.Item>
        </Layout.Section>

        <Layout.Section size="small">
          <Layout.Item>
            <BookingInfoCard
              customer={{
                id: '1',
                customerType: staticCustomerType.personal.toLowerCase(),
                firstName: '篤司',
                lastName: '井高',
                email: 'contact@info.com',
                phone: '09077866565',
              }}
              bookingDetail={{
                entryFee: true,
                numberOfPeople: 11,
                purpose: OrderPurpose.Event,
                saleOfGoods: false,
                exceed: 10,
                contactOfRepresentative: {
                  name: '篤司 井高 ',
                  email: 'contact@info.com',
                  phone: '09077866565',
                },
              }}
              discountDetail={{
                discount: 99,
                limit: 9,
              }}
              usageScheduleDetails={{
                approval: true,
                organizer: '有限会社 渚',
                eventName: '花祭り',
                publishableDate: moment(),
              }}
              loading={false}
              disabled={false}
              editable={false}
            />
          </Layout.Item>

          <Layout.Item>
            <MemoCard />
          </Layout.Item>

          <Layout.Item>
            <TagsCard />
          </Layout.Item>
        </Layout.Section>
      </Layout>
    </>
  )
}

export default IdPage
